<template>
  <div class="products">
    <div style="width: 100%" v-if="subCategories && subCategories.length > 0">
      <vs-col
        style="padding: 0"
        class="mb-10"
        v-for="(subCategory, index) in subCategories"
        :key="index"
      >
        <h4 class="subcategory">{{ subCategory.title }}</h4>
        <vs-col
          v-for="(product, index) in subCategory.items"
          :key="index"
          class="product-cont"
          vs-lg="3"
          vs-sm="4"
          vs-xs="6"
        >
          <product
            :product="product"
            :shoppingCard="shoppingCard"
            @select="$emit('select', product)"
            @remove="$emit('remove', product)"
          ></product>
        </vs-col>
      </vs-col>
    </div>
    <div style="width: 100%" v-else-if="products && products.length > 0">
      <vs-col
        vs-lg="3"
        vs-sm="4"
        vs-xs="6"
        v-for="(product, index) in products"
        :key="index"
        class="product-cont"
      >
        <product
          :product="product"
          :shoppingCard="shoppingCard"
          @select="$emit('select', product)"
          @remove="$emit('remove', product)"
        ></product>
      </vs-col>
    </div>
    <vs-alert v-else color="warning" icon-pack="feather" icon="icon-info">
      محصولی جهت نمایش موجود نیست
    </vs-alert>
  </div>
</template>

<script>
import Product from "./Product.vue";

export default {
  name: "Products",
  components: { Product },
  data() {
    return {
      activeSubCategory: null,
      products: this.activeCategory ? this.activeCategory.items : null,
      subCategories: this.activeCategory
        ? this.activeCategory.subCategories
        : null,
    };
  },
  watch: {
    activeCategory(category) {
      this.products = category ? category.items : null;
      this.subCategories = category ? category.subCategories : null;
    },
  },
  props: {
    shoppingCard: {
      type: Array,
      required: true,
    },
    activeCategory: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.products {
  display: flex;
  flex-direction: column;
  min-height: 600px;
  padding-bottom: 200px;
  margin-left: 190px;

  @media (max-width: 700px) {
    margin-left: 0;
  }
}

.product-cont {
  padding: 0;
  margin-bottom: 0;
  float: left !important;
  position: relative;

  @media (max-width: 350px) {
    width: 50% !important;
  }

  @media (min-width: 350px) and (max-width: 800px) {
    width: 33.3% !important;
  }

  @media (min-width: 800px) and (max-width: 900px) {
    width: 25% !important;
  }

  @media (min-width: 1100px) and (max-width: 1200px) {
    width: 16.6% !important;
  }

  @media (min-width: 1400px) {
    width: 16.6% !important;
  }

  @media (min-width: 1550px) {
    width: 12.5% !important;
  }
}

.subcategory {
  margin-bottom: 8px;
}
</style>
